import config from '@app/config'
import { getCookie } from '@app/services'

export const getB2CUserCulture = (): string | undefined => {
  return getCookie(config.variables.b2c_language) || undefined
}
